/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Selling_In_60_SecondsInputs */

const en_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start selling in 60 seconds.`)
};

const es_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza a vender en 60 segundos.`)
};

const fr_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencez à vendre en 60 secondes.`)
};

const de_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginne in 60 Sekunden mit dem Verkauf.`)
};

const ja_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60秒で販売開始。`)
};

const zh_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 秒内开始销售。`)
};

const ar_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ البيع في 60 ثانية.`)
};

const id_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai berjualan dalam 60 detik.`)
};

const it_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia a vendere in 60 secondi.`)
};

const ru_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начните продавать за 60 секунд.`)
};

const pt_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece a vender em 60 segundos.`)
};

const ko_start_selling_in_60_seconds = /** @type {(inputs: Start_Selling_In_60_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60초 안에 판매를 시작하세요.`)
};

/**
* | output |
* | --- |
* | "Start selling in 60 seconds." |
*
* @param {Start_Selling_In_60_SecondsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const start_selling_in_60_seconds = /** @type {((inputs?: Start_Selling_In_60_SecondsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Selling_In_60_SecondsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_start_selling_in_60_seconds(inputs)
	if (locale === "es") return es_start_selling_in_60_seconds(inputs)
	if (locale === "fr") return fr_start_selling_in_60_seconds(inputs)
	if (locale === "de") return de_start_selling_in_60_seconds(inputs)
	if (locale === "ja") return ja_start_selling_in_60_seconds(inputs)
	if (locale === "zh") return zh_start_selling_in_60_seconds(inputs)
	if (locale === "ar") return ar_start_selling_in_60_seconds(inputs)
	if (locale === "id") return id_start_selling_in_60_seconds(inputs)
	if (locale === "it") return it_start_selling_in_60_seconds(inputs)
	if (locale === "ru") return ru_start_selling_in_60_seconds(inputs)
	if (locale === "pt") return pt_start_selling_in_60_seconds(inputs)
	return ko_start_selling_in_60_seconds(inputs)
});